module.exports = require('./helpers/bundle-url').getBundleURL('iEWGC') + "logo.c51670a8.svg";